import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get all orders for web user
export const getWebOrder = createAsyncThunk("order/customers-order", async (data, { rejectWithValue }) => {
  // const token = localStorage.getItem("authToken");
  const userId = localStorage.getItem("UserRowId");
  
  console.log("Fetching orders for userId:", userId);

  try {
    // Fix: Use GET method with userId in URL, not POST
    const response = await axios.get(
      `${baseUrl}sales/orders/api/v1/get-AllOrder-By-WebUser/${userId}`,
      {
        headers: {
          // "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    
    console.log("getWebOrder response ", response.data);
    return response.data; // Return the data directly
  } catch (error) {
    console.error("Error fetching getWebOrder:", error);
    return rejectWithValue(error.response?.data?.message || "error in getWebOrder");
  }
});

// get single sale order
// get single sale order
export const getSingleOrder = createAsyncThunk("client/get-sales-order", async (orderId, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  console.log("Fetching single order with ID:", orderId);

  try {
    const response = await axios.get(
      `${baseUrl}sales/orders/api/v1/getSalesOrderById/${orderId}`,
      {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    console.log("get single sale order response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching single order:", error);
    return rejectWithValue(error.response?.data?.message || "error in getSingleSaleOrder");
  }
});
// export const getSingleOrder = createAsyncThunk("client/get-sales-order", async (orderId, { rejectWithValue }) => {
//   const token = localStorage.getItem("authToken");
//   console.log("Fetching single order:", orderId);

//   try {
//     const response = await axios.get(`${baseUrl}webapp/orders/api/v1/get-sales-order/${orderId}`, {
//       headers: {
//         "Authorization": `Bearer ${token}`,
//       },
//     });
//     console.log("get single sale order response ", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching getSingleSaleOrder:", error);
//     return rejectWithValue(error.response?.data?.message || "error in getSingleSaleOrder");
//   }
// });

export const createOrder = createAsyncThunk("order/create-order", async (orderData, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}webapp/orders/api/v1/create-order`, orderData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    console.log("create order response ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating order:", error);
    return rejectWithValue(error.response?.data?.message || "error in createOrder");
  }
});

// create bulky order
export const createBulkyOrder = createAsyncThunk("order/create-bulky-order", async (orderData, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}webapp/orders/api/v1/create-bulky-order`, orderData, {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });
    console.log("create bulky order response ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating bulky order:", error);
    return rejectWithValue(error.response?.data?.message || "error in createBulkyOrder");
  }
});

// create non bulky order
export const createNonBulkyOrder = createAsyncThunk("order/create-non-bulky-order", async (orderData, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}webapp/orders/api/v1/create-non-bulky-order`, orderData, {
      headers: {
        "Authorization": `Bearer ${token}`,
      }, 
    });
    console.log("create non bulky order response ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating non bulky order:", error);
    return rejectWithValue(error.response?.data?.message || "error in createNonBulkyOrder");
  }
});